
type SectionCardProps = {
    children?: React.ReactNode;
    title: string;
    subtitle: string;
    subtitle2?: string;
    gradClass?: string
};

const SectionCard: React.FC<SectionCardProps> = ({ children, title, subtitle, subtitle2, gradClass }) => {


    return (<div className={gradClass ? gradClass + ' rewamped-section-card' : 'rewamped-section-card'} >
        <div className='sec-head'>
            <div className="sec-head-title1">
                {title}
            </div>
            <div className="sec-head-title2">
                {subtitle}
            </div>
            {subtitle2 && <div className="sec-head-title3">
                {subtitle2}
            </div>}
        </div>
        {children && <>{children}</>}
    </div>)
}

export default SectionCard;